<template>
  <div class="order-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.reserve_order') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.reserve_order') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="customReserveOrder"/>
      </div>
      <div class="page-right ">
        <!-- <div class="search-block">
          <select class="light-border" v-model="date">
            <option value="">全部订单</option>
            <option value="1">一周内</option>
            <option value="2">一个月内</option>
            <option value="3">六个月内</option>
            <option value="4">一年内</option>
          </select>
          <div class="btn btn-orange" @click="handleDateSearch">搜寻</div>
        </div> -->
        <div class="table-list" ref="tableList">
          <div class="table-header hide-on-pad-flex">
            <div class="td date">{{ $t('reserve_order_page.date') }}</div>
            <div class="td store">{{ $t('reserve_order_page.store') }}</div>
            <div class="td process">{{ $t('reserve_order_page.status') }}</div>
            <div class="td price">{{ $t('reserve_order_page.time') }}</div>
            <div class="td note">{{ $t('reserve_order_page.remark') }}</div>
          </div>
          <div class="table-body">
            <div class="tr" v-for="(item,index) in list" :key="item.no">
              <div class="td date"><span class="td-title show-on-pad">{{ $t('reserve_order_page.date') }}: </span>{{ item.booking_date }}</div>
              <!-- <div class="td no"><span class="td-title show-on-pad">订单编号: </span>{{ item.no }}</div> -->
              <div class="td store"><span class="td-title show-on-pad">{{ $t('reserve_order_page.store') }}: </span>{{ item.retailer_name }}</div>
              <div class="td process"><span class="td-title show-on-pad">{{ $t('reserve_order_page.status') }}: </span>{{ formatProcessStatus(item.process) }}</div>
              <div class="td price"><span class="td-title show-on-pad">{{ $t('reserve_order_page.time') }}: </span>{{ item.booking_time }}</div>
              <div class="td note">
                <span class="td-title show-on-pad">{{ $t('reserve_order_page.remark2') }}: </span>
                {{ item.note?item.note:'无' }}
                <div class="btn btn-light-orange" @click="handleCancel(item.id,index)" v-if="item.process=='1'">{{ $t('btns.order_cancel') }}</div>
              </div>
            </div>
            <div class="tr  hide-on-pad">
              {{ $t('reserve_order_page.page_remark') }}
            </div>
          </div>
        </div>
        <!-- <div class="pagination-block">
          <div class="pagination-tool mr-20  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(1)">首页</div>
          <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(pages-1)">前一页</div>
          <el-pagination
            :page-size="count"
            :pager-count="5"
            layout="pager"
            :current-page="pages"
            :total="totalPage"
            class="custom-pagination"
            :disabled="listLoading"
            @current-change="handelPaginationChange"
          >
          </el-pagination>
          <div class="pagination-tool  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(pages+1)">下一页</div>
          <div class="pagination-tool ml-20  hide-on-pad" :class="{ disabled:listLoading || totalPage<=10 }" @click="goPage(totalPage/count)">末页</div>
        </div> -->
        <!-- <Pagination
          :pageSize="count"
          :pages="pages"
          :total="totalPage"
          :listLoading="listLoading"
          @handelPaginationChange="handelPaginationChange"
        /> -->
      </div>
    </div>
  </div>
</template>

<script>
import userSideMenu from '../../components/UserSideMenu'
import Pagination from '../../components/Pagination/NewPagination.vue';
import { getReservation, cancelReservation } from '../../api/index';
import { Loading } from 'element-ui';
import { cloudConfirm } from '../../utils/tools.js'

  export default {
    name: 'order',
    data() {
      return {
        pages: 0,
        count: 100,
        totalPage: 10,
        date: '',
        list: [],
        gettingList: false,
        listLoading: true,
      }
    },
    components: {
      userSideMenu,Pagination
    },
    filters: {
      
    },
    created() {
      
    },
    mounted() {
      this.$nextTick(() => {
        this.getList();
      });
    },
    methods: {
      formatProcessStatus(value) {
        console.log('formatPayStatus',value);
        switch(value) {
          case 1:
            return this.$t('format.reserve_process1');
            break;
          case 2:
            return this.$t('format.reserve_process2');
            break;
          case 3:
            return this.$t('format.reserve_process3');
            break;
          case 4:
            return this.$t('format.reserve_process4');
            break;
        }
      },
      async getList(options={}) {
        const { index='',clean=false } = options;
        let { store_id } = this.$route.query;

        // 下面切换第几页时会自动加pages，所以如果有传index就不要再++了
        if(!index) {
          this.pages++;
        }
        if(clean) {
          this.pages = 1
        }
        const data = {
          count: this.count,
          store_id
        };
        this.listLoading = true;
        console.log(this.$refs.tableList);
        let loadingInstance = Loading.service({ target: this.$refs.tableList });
        const { list,total } = await getReservation(data);
        setTimeout(() => {
          this.list = list;
          this.listLoading = false;
          this.totalPage = total;
          console.log('list',list);
          loadingInstance.close();
        }, 1000);

      },
      // goPage(index) {
      //   if(this.listLoading) return; 
      //   if(this.totalPage<=10) return;
      //   if(index<1) index = 1;
      //   if(index>this.totalPage/this.count) index = this.totalPage/this.count;
      //   this.pages = index;
      //   this.getList({index});
      // },
      handelPaginationChange(val) {
        // this.goPage(index);
        this.pages = val;
        this.getList({index:val});
      },
      handleDateSearch() {
        if(this.listLoading) return; 
        this.getList({clean:true});
      },
      async handleCancel(id,index) {
        let { store_id } = this.$route.query;
        try {
          await cloudConfirm({
            text: this.$t('alert_message.cancel_order')
          });
          const loadingInstance = this.$loading();
          const res = await cancelReservation({
            store_id,
            bookingID: id
          });
          this.list[index].process = 4;
          loadingInstance.close();
        } catch (error) {
          
        }
      }
    }
  }
</script>

<style lang="less" scoped>
.order-page {
  @media (max-width: 992px) {
    background: #F7F8FA;
    .page-container {
      padding-top: 0;
    }
  }
  .search-block {
    display: flex;
    margin-bottom: 60px;
    select {
      flex: 1;
    }
    .btn {
      margin-left: 40px;
      width: 120px;
    }
    @media (max-width: 992px) {
      margin-bottom: 20px;
      .btn {
        margin-left: 20px;
        width: 100px;
      }
    }
  }
  .table-list {
    text-align: center;
    .table-header {
      display: flex;
      background: #F0F0F0;
      padding: 10px;
    }
    .table-body {
      display: flex;
      flex-direction: column;
    }
    .tr {
      display: flex;
      padding: 20px 0;
      border-bottom: 1px solid #E6E6E6;
    }
    .date {
      flex: 0 0 20%;
    }
    // .no {
    //   flex: 0 0 19%;
    // }
    .store {
      flex: 0 0 20%;
    }
    .process{
      flex: 0 0 20%;
    }
    .price {
      flex: 0 0 20%;
    }
    .note {
      flex: 0 0 20%;
      .btn {
        margin-top: 10px;
      }
    }
    @media (max-width: 992px) {
      text-align: left;
      font-weight: 400;
      .tr {
        flex-direction: column;
        background: white;
        border-bottom: unset;
        // border-radius: 5px;
        margin-bottom: 20px;
        box-shadow: 0 5px 6px #D2D3D7;
        padding: 20px 10px;
        .td {
          color: black;
          margin-bottom: 13px;
          display: flex;
          &:nth-last-child(1) {
            margin-bottom: 0;
          }
          .td-title {
            color: #707070;
            margin-right: 10px;
          }
          &.date {
            .td-title {
              color: black;
            }
            border-bottom: 2px solid #E6E6E6;
            padding-bottom: 10px;
            position: relative;
            .span-status {
              position: absolute;
              right: 10px;
              opacity: .5;
              top: 0px;
            }
          }
          &.note {
            position: relative;
            padding-right: 100px;
            .btn {
              margin-top: 0px;
              position: absolute;
              bottom: 0;
              right: 10px;
              padding: 10px 14px;
              border-radius: 10px;
            }
          }
        }
      }
    }
  }
  .pagination-block {
    padding: 30px 0;
    display: flex;
    justify-content: center;
    .pagination-tool {
      line-height: 28px;
      cursor: pointer;
      font-weight: 500;
      color: #707070;
      &.disabled {
        color: #C0C4CC;
        cursor: not-allowed;
      }
    }
    /deep/ .custom-pagination {
      display: flex;
      justify-content: center;
      li {
        border-radius: 50%;
        min-width: unset;
        width: 28px;
        margin-right: 20px;
        &:nth-child(1) {
          margin-left: 20px;
        }
      }
      li.active,li:hover {
        background: #ec4f00;
        color: white;
      }
    }
  }
}
</style>